@if (announcementDetail) {
  <div class="announcement-details-content">
    <!-- Header Info -->
    <div class="info-header">
      <div class="info-grid">
        <div class="info-item">
          <span class="label">From</span>
          <span class="value">{{ announcementDetail.from_email }}</span>
        </div>
        <div class="info-item">
          <span class="label">Date</span>
          <span class="value">{{
            announcementDetail.created_on_utc | date: "MMM d, y, h:mm a"
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">Type</span>
          <div class="type-badges">
            @if (announcementDetail.email) {
              <span class="type-badge email">Email</span>
            }
            @if (announcementDetail.notification) {
              <span class="type-badge notification">Notification</span>
            }
          </div>
        </div>
        @if (hasRecipients && getRecipients().length > 0) {
          <div class="info-item recipients-item">
            <span class="label">Recipients</span>
            @if (getRecipients().length === 1) {
              <span class="recipient-badge">{{ getRecipients()[0] }}</span>
            } @else {
              <button
                class="recipients-count-btn"
                (click)="toggleRecipients()"
                [attr.aria-expanded]="isRecipientsExpanded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <span>{{ getRecipients().length }}</span>
                <svg
                  class="chevron"
                  [class.open]="isRecipientsExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              @if (isRecipientsExpanded) {
                <div class="recipients-badges">
                  @for (recipient of getRecipients(); track $index) {
                    <span class="recipient-badge">{{ recipient }}</span>
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    </div>

    <!-- Message -->
    <div class="content-block">
      <h2 class="block-title">{{ announcementDetail.subject }}</h2>
      <div class="filter-divider"></div>
      <div
        class="block-content message-body"
        [innerHTML]="announcementMessageSafeHtml"
      ></div>
    </div>
  </div>
}
